import { Entry } from 'contentful'
import { Document } from '@contentful/rich-text-types'

import { IPartner, IPartnerFields } from 'generated/types/contentful'
import { parseProduct, Product } from 'services/ContentfulService/models/product'
import { Asset, parseAsset } from 'services/ContentfulService/models/asset'
import { ContentfulEntity, parseSystemFields } from 'services/ContentfulService/utils'

export interface Partner extends ContentfulEntity {
	products: Product[]
	id: string
	logo: Asset
	name: string
	relativePath: string
	productName?: string
	color?: string
	description?: Document
	slug: string
	type: IPartner['fields']['type']
	website?: string
	displayRank: number
}

const defaultLogo: Asset = { aspectRatio: 0, contentType: '', description: '', id: '', title: '', url: '' }
export const parsePartner = (rawPartner: Entry<IPartnerFields>): Partner => {
	const fields = rawPartner.fields
	return {
		color: fields.primaryColor,
		logo: fields.logo ? parseAsset(fields.logo) : defaultLogo,
		productName: fields.productName,
		name: fields.name,
		id: rawPartner.sys.id,
		relativePath: `/learn/partners/${fields.slug}`,
		description: fields.description,
		products: (fields.availableProducts || []).map(p => parseProduct(p, true)),
		slug: fields.slug,
		type: fields.type,
		website: fields.website,
		sys: parseSystemFields(rawPartner.sys),
		displayRank: fields.displayRank || Number.MAX_VALUE
	}
}
